import { render, staticRenderFns } from "./SiderBar.vue?vue&type=template&id=2abed793"
import script from "./SiderBar.vue?vue&type=script&lang=js"
export * from "./SiderBar.vue?vue&type=script&lang=js"
import style0 from "./SiderBar.vue?vue&type=style&index=0&id=2abed793&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports